import React from 'react';
import styles from './styles.module.scss';
import Modal from '@/components/component-library/Modal';
import Text from '@/components/component-library/Text';
import ButtonCTA from '@/components/component-library/Button/CTA';
import { classes } from '@/helpers/styling';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import useLanguage from '@/hooks/language/useLanguage';

const LanguageSelector = () => {
  const {
    preferredLocale,
    languageSelectorPromptMode,
    handleSelectLanguage,
    languageSelectorOpen,
    handleCloseLanguageSelectorWithoutSelection
  } = useLanguage();

  const preferredLocaleConfig = preferredLocale;

  return (
    <Modal
      id='language-selector'
      onClick={handleCloseLanguageSelectorWithoutSelection}
      open={languageSelectorOpen}
      zIndex={111}
    >
      <LayoutWrapperHorizontal className={styles.languageSelectorModalContent} fillHeight>
        <Text bold className={styles.title}>
          Choose your language
        </Text>
        {languageSelectorPromptMode ? (
          <Text className={styles.description}>
            Choose language: {preferredLocaleConfig}
          </Text>
        ) : (
          <Text className={styles.description}>
            Choose language
          </Text>
        )}
        <div className={styles.selectorButtons}>
          {languageSelectorPromptMode && (
            <ButtonCTA
              className={classes(
                styles.selectLanguageButton,
                styles.selectPreferredLanguageButton,
                styles.blue
              )}
              isRectangular
              onClick={(e) => {
                e.stopPropagation();
                handleSelectLanguage(preferredLocale);
              }}
            >
              Change to language: {preferredLocaleConfig}
            </ButtonCTA>
          )}
          {['English', 'Spanish', 'French'].map((l) => (
            <ButtonCTA
              className={styles.selectLanguageButton}
              isRectangular
              key={l}
              onClick={(e) => {
                e.stopPropagation();
                handleSelectLanguage(l);
              }}
            >
              {l}
            </ButtonCTA>
          ))}
        </div>
      </LayoutWrapperHorizontal>
    </Modal>
  );
};

export default LanguageSelector;
